export const today = '今天';

export const endMax = '9999-12';

/**
 * 获取年份数据
 * @param relativeYear
 */
export function getYearFieldData(relativeYear: number = 0): any[] {
  const yearData: any[] = [];
  const duration = 100;
  const thisYear = new Date().getFullYear() + relativeYear;
  for (let year = thisYear; year >= thisYear - duration; year--) {
    const item = {
      value: year.toString(),
      labelName: year.toString()
    };
    yearData.push(item);
  }
  return yearData;
}

/**
 * 设置结束月份
 * @param value
 * @param key
 */
export function setEndDatePickerValue(value: string, key: number) {
  const endMonthPickerInput = document.querySelectorAll(
    `.abs-range-month-picker.abs-month-picker-${key} .ant-calendar-picker-input`
  )[1] as HTMLInputElement;

  if (endMonthPickerInput) {
    setTimeout(() => {
      endMonthPickerInput.value = value;
    }, 100);
  }
}

/**
 * 设置年份的数据
 */
interface IAdvancedYearData {
  start?: number;
  end?: number;
  maxEndYear?: number;
  maxStartYear?: number;
  closeEqual?: boolean;
}

export function getFromYearData({
  end,
  maxStartYear,
  closeEqual
}: IAdvancedYearData) {
  const yearData: any[] = [];
  const duration = 100;
  let start;
  end = end
    ? Number(end)
    : closeEqual
    ? new Date().getFullYear() + 1
    : new Date().getFullYear();
  if (maxStartYear && Number(end) > maxStartYear) {
    end = closeEqual ? maxStartYear + 1 : maxStartYear;
  }
  start = Number(end) - duration;
  for (let year = end; year >= start; year--) {
    if (closeEqual && year === end) {
      continue;
    }
    const item = {
      value: year.toString(),
      labelName: year.toString()
    };
    yearData.push(item);
  }
  return yearData;
}

export function getToYearData({
  start,
  maxEndYear,
  closeEqual
}: IAdvancedYearData) {
  const yearData: any[] = [];
  const duration = 100;
  let end;
  if (maxEndYear) {
    start = start ? Number(start) : maxEndYear - duration;
    end = maxEndYear;
  } else {
    start = start ? Number(start) : new Date().getFullYear() - duration;
    end = Number(start) + duration;
  }

  for (let year = end; year >= start; year--) {
    if (closeEqual && year === start) {
      continue;
    }
    const item = {
      value: year.toString(),
      labelName: year.toString()
    };
    yearData.push(item);
  }
  return yearData;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/utils.ts